import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import LinkButton from '@/components/link_button/Index.vue';
import PageTransition from '@/components/page_transition/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let Overview = class Overview extends Mixins(RouterParamsAppMixin, ViewportSizeMixin) {
};
Overview = __decorate([
    Component({
        components: {
            PageTitle,
            LinkButton,
            PageTransition,
        },
    })
], Overview);
export default Overview;
